<div class="stu">
  <header class="stu__header">
    <div>
      <h1 class="stu__title">
        <span class="stu__title-icon">
          <i class="fa-solid fa-user-graduate" aria-hidden="true"></i>
        </span>
        {{ 'ADMIN.STUDENTS' | translate }}
      </h1>
      <p class="stu__subtitle">{{ 'ADMIN.STUDENTS_SUBTITLE' | translate }}</p>
    </div>

    <div class="stu__actions">
      <!-- Ajouter un élève : action de l'écran, indépendante des facettes
           (le parcours se choisit dans le modal). -->
      @if (canWrite) {
        <button type="button" class="stu__add" (click)="addStudent()" [disabled]="isLoading">
          <i class="fa-solid fa-plus" aria-hidden="true"></i>
          {{ 'ADMIN.ADD_STUDENT' | translate }}
        </button>
      }
    </div>
  </header>

  @if (!canWrite) { <app-read-only-notice></app-read-only-notice> }

  <!-- Filtres harmonisés (banque de questions) : parcours + statut, cumulables -->
  <app-filter-bar
    [activeCount]="activeFilterCount"
    [resultCount]="visibleStudents.length"
    [totalCount]="students.length"
    [search]="search"
    searchPlaceholderKey="FILTERS.SEARCH_STUDENT_PLACEHOLDER"
    (searchChange)="onSearchChange($event)"
    (reset)="resetFilters()">

    <app-searchable-select
      [options]="pathOptions" [value]="selectedPathId"
      [allLabel]="'FILTERS.ALL_PATHS' | translate"
      [placeholder]="'ADMIN.SELECT_PATH' | translate" icon="fa-solid fa-route"
      [disabled]="isLoadingPaths"
      (valueChange)="onPathChange($event)">
    </app-searchable-select>

    <div class="stu__seg">
      <button type="button" [class.is-active]="statusFilter === 'all'"
        (click)="onStatusFilter('all')">{{ 'ADMIN.STATUS_ALL' | translate }}</button>
      <button type="button" [class.is-active]="statusFilter === 'active'"
        (click)="onStatusFilter('active')">{{ 'ADMIN.ACTIVE' | translate }}</button>
      <button type="button" [class.is-active]="statusFilter === 'inactive'"
        (click)="onStatusFilter('inactive')">{{ 'ADMIN.INACTIVE' | translate }}</button>
    </div>
  </app-filter-bar>

  <app-data-table
    [columns]="columns"
    [rows]="visibleStudents"
    [rowTemplate]="rowTpl"
    [loading]="isLoading"
    [errored]="hasError"
    [sortBy]="sortBy"
    [sortDescending]="sortDescending"
    emptyIcon="user-graduate"
    [emptyTitleKey]="emptyTitleKey"
    [emptyMessageKey]="emptyMessageKey"
    errorTitleKey="ADMIN.ERROR_LOADING_STUDENTS_TITLE"
    errorMessageKey="ADMIN.ERROR_LOADING_STUDENTS"
    (sortChange)="onSort($event)"
    (retry)="loadStudents()">
  </app-data-table>
</div>

<!-- Gabarit de ligne : le tableau générique rend le <tr>, on fournit les <td>. -->
<ng-template #rowTpl let-s>
  <td>{{ s.firstName }}</td>
  <td>{{ s.lastName }}</td>
  <td>{{ s.email }}</td>
  <td>{{ s.learningPath?.title || '—' }}</td>
  <td class="text-center">
    <span class="stu__pill" [attr.data-status]="s.isActive ? 'active' : 'inactive'">
      {{ (s.isActive ? 'ADMIN.ACTIVE' : 'ADMIN.INACTIVE') | translate }}
    </span>
  </td>
  <td class="text-center">
    <div class="stu__row-actions">
      <button type="button" class="stu__action" (click)="onShowStudent(s)"
        [title]="'COMMON.VIEW' | translate" [attr.aria-label]="'COMMON.VIEW' | translate">
        <i class="fa-solid fa-eye" aria-hidden="true"></i>
      </button>
      <!-- Le rapport de diagnostic a rejoint le suivi des élèves, où il est
           porté par l'élève au-dessus de ses copies. Cet écran-ci gère les
           fiches : y laisser le rapport le montrait à qui vient corriger une
           adresse, et le cachait à qui vient lire des résultats. -->
      @if (canWrite) {
        <button type="button" class="stu__action" (click)="onEditStudent(s)"
          [title]="'COMMON.EDIT' | translate" [attr.aria-label]="'COMMON.EDIT' | translate">
          <i class="fa-solid fa-pen" aria-hidden="true"></i>
        </button>
        <button type="button" class="stu__action stu__action--danger" (click)="onDeleteStudent(s)"
          [title]="'COMMON.DELETE' | translate" [attr.aria-label]="'COMMON.DELETE' | translate">
          <i class="fa-solid fa-trash" aria-hidden="true"></i>
        </button>
      }
    </div>
  </td>
</ng-template>

<!-- ADD/EDIT STUDENT MODAL -->
<app-modal [title]="(isEditMode ? 'ADMIN.EDIT_STUDENT' : 'ADMIN.ADD_STUDENT') | translate" [size]="'lg'"
  [show]="showStudentModal" [hasFooter]="false" (closed)="onModalClosed()">
  <app-add-student [isEditMode]="isEditMode" [student]="selectedStudent" [learningPathId]="selectedPathId"
    [learningPaths]="learningPaths" [saving]="isSaving" (saved)="handleStudentSaved($event)"
    (cancelled)="onModalClosed()">
  </app-add-student>
</app-modal>
